import React from 'react';
const context = React.createContext(null);

export const Provider = context.Provider;
export const Context = context;

export default context;
